var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBellLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 17.5c-1.07-.01-2.67.14-3.43.92-.33.33-.51.7-.56 1.07-.07.62.09 1.15.45 1.53.38.37.91.53 1.53.45.38-.04.74-.23 1.07-.56.78-.77.95-2.25.94-3.32",
  stroke: "#222B3E",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 17.5h3.63c1.04 0 1.87-.84 1.87-1.87 0-.41-.13-.8-.37-1.13L18 13V8.5c0-3.31-2.69-6-6-6s-6 2.69-6 6V13l-1.5 1.5a1.88 1.88 0 0 0 1.5 3h2",
  stroke: "#222B3E",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIcBellLine;